import type { ReactNode } from 'react';
import { formatDateTime } from '@/utils/format';

// Shared cell renderers for the Suspicious Trades grids. Mirror the legacy
// ts-suspicious-trades-renderers.js (renderTsPriority / renderTsStatus) and the
// site's renderDateTime.

export function renderDateTime(value?: string | null): ReactNode {
  return formatDateTime(value);
}

// Priority badge: Low → bg-warning, Medium → bg-orange, else (High) → bg-danger.
export function renderTsPriority(priority?: string | null): ReactNode {
  if (!priority) return '';
  const p = priority.toLowerCase();
  const cls = p === 'low' ? 'bg-warning' : p === 'medium' ? 'bg-orange' : 'bg-danger';
  return <span className={`badge ${cls}`}>{priority}</span>;
}

// Status badge: Resolved → bg-primary, else → bg-warning.
export function renderTsStatus(statusName?: string | null): ReactNode {
  if (!statusName) return '';
  const cls = statusName.toLowerCase() === 'resolved' ? 'bg-primary' : 'bg-warning';
  return <span className={`badge ${cls}`}>{statusName}</span>;
}
